var map = {
	"./data.cs.json": 263,
	"./data.da.json": 264,
	"./data.de.json": 265,
	"./data.en-AU.json": 266,
	"./data.en-CA.json": 267,
	"./data.en-EU.json": 268,
	"./data.en-GB.json": 269,
	"./data.en-US.json": 270,
	"./data.es.json": 271,
	"./data.fr-CA.json": 272,
	"./data.fr.json": 273,
	"./data.hu-HU.json": 274,
	"./data.it.json": 275,
	"./data.nl.json": 276,
	"./data.no.json": 277,
	"./data.pl.json": 278,
	"./data.pt.json": 279,
	"./data.ru.json": 280,
	"./data.sl.json": 281,
	"./data.sv.json": 282
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 262;